import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RecordingPortal from './components/RecordingPortal';
import { UploadProvider } from './context/UploadContext';

// Import styles in order: layout → components → responsive
import './RecordingPortal/styles/layout.css';
import './RecordingPortal/styles/sidebar.css';
import './RecordingPortal/styles/mobile-header.css';
import './RecordingPortal/styles/project-introduction.css';
import './RecordingPortal/styles/stats-bar.css';
import './RecordingPortal/styles/deliverable-group.css';
import './RecordingPortal/styles/articulation-card.css';
import './RecordingPortal/styles/dynamic-card.css';
import './RecordingPortal/styles/status-badge.css';
import './RecordingPortal/styles/review-notes.css';
import './RecordingPortal/styles/upload-zone.css';
import './RecordingPortal/styles/notices.css';
import './RecordingPortal/styles/footer.css';
import './RecordingPortal/styles/responsive.css';

function App() {
  return (
    <BrowserRouter>
      <UploadProvider>
        <Routes>
          {/* Magic link: /:slug/:token */}
          <Route path="/:slug/:token" element={<RecordingPortal />} />
          {/* Legacy slug-only (open portals without access_token) */}
          <Route path="/:slug" element={<RecordingPortal />} />
          
          {/* Root route: show a message or redirect */}
          <Route path="/" element={<NoProjectSelected />} />
        </Routes>
      </UploadProvider>
    </BrowserRouter>
  );
}

function NoProjectSelected() {
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '16px',
      color: 'var(--color-text-secondary)'
    }}>
      <h1 style={{ color: 'var(--color-text-primary)', fontSize: '1.5rem' }}>
        Auddict Recording Portal
      </h1>
      <p>No project selected. Please use your project link to access your recordings.</p>
    </div>
  );
}

export default App;
